import { Skeleton } from '../../../common/skeleton/Skeleton';
import styles from './PaymentSummaryLoader.module.scss';

export const PaymentSummaryLoader = () => (
  <div className={styles['paymentSummary-loader-container']} data-testid={'paymentSummary-loader-container'}>
    <div className={styles['paymentSummary-loader-container-external-payment']}>
      {[1, 2].map((key) => (
        <div key={key} className={styles['option-wrapper']}>
          <Skeleton borderRadius="8" height="24" width="25" />
          <div className={styles['label-wrapper']}>
            <Skeleton borderRadius="8" height="24" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
